import React, { Component } from 'react';
import styled from 'styled-components';
import { AUTH_UPDATE_BG } from '../../config/media';

const Wrapper = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	.bg-wrapper-text {
		position: absolute;
		bottom: 60px;
		left: 60px;
		color: #fff;
		h2 {
			font-size: 32px;
			color: #fff;
			font-weight: bold;
		}
		p {
			font-size: 14px;
			line-height: 16px;
		}
		.btn-link {
			color: #fff;
			font-size: 10px;
			padding: 7px 14px;
			border: 2px solid #fff;
			text-decoration: none;
			font-weight: bold;
		}
	}
	.bg-wrapper-image {
		width: 100%;
		height: 100%;
		background-position: center;
		background-size: cover;
		background-image: url(${AUTH_UPDATE_BG});
	}
`;

class Update extends Component {
	render() {
		return (
			<Wrapper>
				<div className="bg-wrapper-image"></div>
				<div className="bg-wrapper-text">
					<h2>Stay up-to-date</h2>
					<p>
						Join the HollaEx telegram channel and stay up-to-date with the
						latest exchange, wallet and token news.
					</p>
					<a
						href="https://t.me/hollaex"
						title="bitholla"
						target="_blank"
						rel="noopener noreferrer"
						className="btn-link"
					>
						Hollaex Channel
					</a>
				</div>
			</Wrapper>
		);
	}
}

export default Update;
